"use strict";

try {
  document.addEventListener('readystatechange', function () {
    if (document.readyState == 'complete') window.dispatchEvent(new Event('resize'));
  });
} catch (e) {}